import * as tslib_1 from "tslib";
import { OnDestroy, } from '@angular/core';
import { UiFolderTreeComponent } from '@components/ui-folder-tree/ui-folder-tree.component';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { FolderType, } from '@models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var UiFolderTreeModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiFolderTreeModalComponent, _super);
    function UiFolderTreeModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.FolderType = FolderType;
        _this._destroyed$ = new Subject();
        return _this;
    }
    Object.defineProperty(UiFolderTreeModalComponent.prototype, "state", {
        get: function () {
            return this.context.data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiFolderTreeModalComponent.prototype, "highlighted", {
        get: function () {
            return this.state.highlighted$.value;
        },
        enumerable: true,
        configurable: true
    });
    UiFolderTreeModalComponent.prototype.ngOnDestroy = function () {
        this.state.searchValue = '';
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    UiFolderTreeModalComponent.prototype.switchFolder = function () {
        var _this = this;
        this.state
            .switchToHighlighted()
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (success) {
            if (success) {
                _this._dialogRef.close({
                    type: 4 /* Succeeded */,
                });
            }
            else {
                _this.state.refresh();
            }
        });
    };
    return UiFolderTreeModalComponent;
}(UiModalComponent));
export { UiFolderTreeModalComponent };
